import { render, staticRenderFns } from "./LabReportForm.vue?vue&type=template&id=55ba0a6a&scoped=true&"
import script from "./LabReportForm.vue?vue&type=script&lang=js&"
export * from "./LabReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba0a6a",
  null
  
)

export default component.exports